// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --matcha-primary: #d1f0b1;
  --matcha-light: #daf3c1;
  --matcha-dark: #a7c08e;
  --celadon-primary: #b6cb9e;
  --celadon-light: #c5d5b1;
  --celadon-dark: #92a27e;
  --cambridge-primary: #92b4a7;
  --cambridge-light: #a8c3b9;
  --cambridge-dark: #759086;
}

* {
  font-family: "Playpen Sans", cursive;
  color: var(--matcha-primary);
}

body {
  margin: 0;
  box-sizing: border-box;
  min-height: 100vh;
  display: grid;
  place-items: center;
  background-color: var(--celadon-primary);
}

.buttons {
  width: 100%;
  margin: 24px;
  gap: 24px;
  display: flex;
  justify-content: center;
  gap: 48px;
}

.buttons > button {
  cursor: pointer;
  border: 0;
  border-radius: 2px;
  background-color: var(--cambridge-primary);
  height: 50px;
  width: 120px;
  box-shadow: 0px 4px 0px 0px var(--cambridge-dark);
  transition: all 0.1s ease-in-out;
}

.buttons > button:hover {
  color: var(--matcha-light);
  box-shadow: 0px 3px 0px 0px var(--cambridge-dark);
  transform: translateY(1px);
}

.buttons > button:active {
  color: var(--matcha-light);
  box-shadow: 0px 0px 0px 0px var(--cambridge-dark);
  transform: translateY(4px);
}

#content {
  padding: 24px;
  min-height: 100vh;
  width: 70vw;
  background-color: var(--cambridge-dark);
  box-shadow: 0px 0px 8px 4px var(--celadon-dark);
  border-left: var(--celadon-dark) 2px solid;
  border-right: var(--celadon-dark) 2px solid;
}

/* HOME TAB */

.home-content > img {
  display: block;
  margin: 0 auto;
  width: auto;
  height: 350px;
  border: solid 2px var(--matcha-light);
  border-radius: 2px;
}

.home-content > p {
  text-align: justify;
}

/* MENU TAB */

.menu-content div {
  display: grid;
  grid-template-areas:
    "image title price"
    "image description description";
  grid-template-columns: auto 1fr auto;
  gap: 24px;
  margin: 24px;
}

.menu-content img {
  height: 250px;
  width: 250px;
  border: 2px solid var(--matcha-light);
  border-radius: 15%;
  box-shadow: 0px 0px 4px 0px var(--matcha-light);
  grid-area: image;
}

.menu-content h1 {
  grid-area: title;
  margin: 0;
  place-self: center start;
}

.menu-content h2 {
  grid-area: price;
  margin: 0;
  place-self: center end;
}

.menu-content p {
  grid-area: description;
  text-align: justify;
  margin: 0;
  place-self: start;
}

/* CONTACT TAB */

.contact-content {
  display: grid;
  grid-template-areas:
    "image location"
    "schedule information";
  grid-template-columns: 1fr auto;
  gap: 24px;
}

.contact-content img {
  place-self: center end;
  grid-area: image;
  height: 600px;
  width: auto;
}

.contact-content .location {
  height: 100%;
  grid-area: location;
  justify-self: center;
  text-align: justify;
}

.location {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.contact-content .schedule {
  grid-area: schedule;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.schedule h2 {
  margin: 0;
}

.schedule span {
  font-weight: 700;
}

.schedule p {
  display: inline;
  margin: 0;
}

.schedule ul {
  padding: 0;
  margin: 0;
}

.schedule li {
  list-style: none;
  display: flex;
  justify-content: space-between;
}

.contact-content .information {
  grid-area: information;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.information p {
  display: inline;
  margin: 0;
}

.information h2 {
  margin: 0;
}

.information span {
  font-weight: 700;
}

.information ul {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.information li {
  list-style: none;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,iDAAiD;EACjD,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,uCAAuC;EACvC,+CAA+C;EAC/C,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA,aAAa;;AAEb;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;;AAEb;EACE,aAAa;EACb;;mCAEiC;EACjC,oCAAoC;EACpC,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb;;0BAEwB;EACxB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[":root {\n  --matcha-primary: #d1f0b1;\n  --matcha-light: #daf3c1;\n  --matcha-dark: #a7c08e;\n  --celadon-primary: #b6cb9e;\n  --celadon-light: #c5d5b1;\n  --celadon-dark: #92a27e;\n  --cambridge-primary: #92b4a7;\n  --cambridge-light: #a8c3b9;\n  --cambridge-dark: #759086;\n}\n\n* {\n  font-family: \"Playpen Sans\", cursive;\n  color: var(--matcha-primary);\n}\n\nbody {\n  margin: 0;\n  box-sizing: border-box;\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  background-color: var(--celadon-primary);\n}\n\n.buttons {\n  width: 100%;\n  margin: 24px;\n  gap: 24px;\n  display: flex;\n  justify-content: center;\n  gap: 48px;\n}\n\n.buttons > button {\n  cursor: pointer;\n  border: 0;\n  border-radius: 2px;\n  background-color: var(--cambridge-primary);\n  height: 50px;\n  width: 120px;\n  box-shadow: 0px 4px 0px 0px var(--cambridge-dark);\n  transition: all 0.1s ease-in-out;\n}\n\n.buttons > button:hover {\n  color: var(--matcha-light);\n  box-shadow: 0px 3px 0px 0px var(--cambridge-dark);\n  transform: translateY(1px);\n}\n\n.buttons > button:active {\n  color: var(--matcha-light);\n  box-shadow: 0px 0px 0px 0px var(--cambridge-dark);\n  transform: translateY(4px);\n}\n\n#content {\n  padding: 24px;\n  min-height: 100vh;\n  width: 70vw;\n  background-color: var(--cambridge-dark);\n  box-shadow: 0px 0px 8px 4px var(--celadon-dark);\n  border-left: var(--celadon-dark) 2px solid;\n  border-right: var(--celadon-dark) 2px solid;\n}\n\n/* HOME TAB */\n\n.home-content > img {\n  display: block;\n  margin: 0 auto;\n  width: auto;\n  height: 350px;\n  border: solid 2px var(--matcha-light);\n  border-radius: 2px;\n}\n\n.home-content > p {\n  text-align: justify;\n}\n\n/* MENU TAB */\n\n.menu-content div {\n  display: grid;\n  grid-template-areas:\n    \"image title price\"\n    \"image description description\";\n  grid-template-columns: auto 1fr auto;\n  gap: 24px;\n  margin: 24px;\n}\n\n.menu-content img {\n  height: 250px;\n  width: 250px;\n  border: 2px solid var(--matcha-light);\n  border-radius: 15%;\n  box-shadow: 0px 0px 4px 0px var(--matcha-light);\n  grid-area: image;\n}\n\n.menu-content h1 {\n  grid-area: title;\n  margin: 0;\n  place-self: center start;\n}\n\n.menu-content h2 {\n  grid-area: price;\n  margin: 0;\n  place-self: center end;\n}\n\n.menu-content p {\n  grid-area: description;\n  text-align: justify;\n  margin: 0;\n  place-self: start;\n}\n\n/* CONTACT TAB */\n\n.contact-content {\n  display: grid;\n  grid-template-areas:\n    \"image location\"\n    \"schedule information\";\n  grid-template-columns: 1fr auto;\n  gap: 24px;\n}\n\n.contact-content img {\n  place-self: center end;\n  grid-area: image;\n  height: 600px;\n  width: auto;\n}\n\n.contact-content .location {\n  height: 100%;\n  grid-area: location;\n  justify-self: center;\n  text-align: justify;\n}\n\n.location {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n\n.contact-content .schedule {\n  grid-area: schedule;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.schedule h2 {\n  margin: 0;\n}\n\n.schedule span {\n  font-weight: 700;\n}\n\n.schedule p {\n  display: inline;\n  margin: 0;\n}\n\n.schedule ul {\n  padding: 0;\n  margin: 0;\n}\n\n.schedule li {\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n}\n\n.contact-content .information {\n  grid-area: information;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.information p {\n  display: inline;\n  margin: 0;\n}\n\n.information h2 {\n  margin: 0;\n}\n\n.information span {\n  font-weight: 700;\n}\n\n.information ul {\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.information li {\n  list-style: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
